export default __webpack_public_path__ + "static/media/Commercial-.dbc6c090.jpg";